export default "__VITE_ASSET__C_G6a4jV__"